import React from "react";
import { NavLink } from "react-router-dom";
import BannerImage2 from "../../assets/images/about-us/about-banner.png";

const BannerSection = () => {
  return (
    <>
      {/* ── Main Hero Section ── */}
      <section className="tw-relative tw-overflow-hidden tw-bg-white tw-py-16 lg:tw-py-24 tw-border-b tw-border-solid tw-border-slate-100" id="home">
        <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-relative tw-z-10">
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
            
            {/* Left Column: Text & Actions */}
            <div className="lg:tw-col-span-7 tw-flex tw-flex-col tw-text-left">
              <h1 className="tw-text-3xl sm:tw-text-4xl lg:tw-text-5xl tw-font-extrabold tw-tracking-tight tw-leading-[1.15] tw-mb-6 tw-text-slate-900">
                ABOUT <span className="tw-text-[#5D44FF]">US!</span>
              </h1>

              <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-5">
                BeyondLeadz is an AI-powered sales and marketing automation platform built specifically for the hospitality industry. We enable hotels, resorts, and travel businesses to streamline lead generation, manage guest interactions, and run hyper-personalized campaigns with ease.
              </p>

              <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-8">
                By combining intelligent automation, real-time data, and deep industry insights, BeyondLeadz helps hospitality brands drive more bookings, enhance guest engagement, and stay ahead in a competitive market.
              </p>

              <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4">
                <NavLink
                  to="/signup"
                  className="hero-btn-shine tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-7 tw-py-3.5 tw-bg-[#5D44FF] hover:tw-bg-indigo-600 tw-text-white tw-font-bold tw-text-sm tw-rounded-xl tw-shadow-lg tw-shadow-indigo-500/20 tw-transition-all hover:tw-scale-[1.03]"
                >
                  Start Free Trial
                </NavLink>
                <NavLink
                  to="/contact-us"
                  className="tw-inline-flex tw-items-center tw-justify-center tw-px-7 tw-py-3.5 tw-bg-transparent tw-border-2 tw-border-solid tw-border-[#5D44FF] hover:tw-bg-indigo-50 tw-text-[#5D44FF] tw-font-bold tw-text-sm tw-rounded-xl tw-transition-all hover:tw-scale-[1.03]"
                >
                  Contact us
                </NavLink>
              </div>
            </div>

            {/* Right Column: Hero Graphic */}
            <div className="lg:tw-col-span-5 tw-flex tw-justify-center tw-relative">
              {/* Decorative radial blur glow */}
              <div className="hero-img-glow" />

              {/* Dash rotating ring */}
              <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-pointer-events-none">
                <div className="hero-ring-rotate hero-ring-size tw-rounded-full tw-border-2 tw-border-dashed tw-border-[#5D44FF]/15" />
              </div>

              {/* Floating Image Wrapper */}
              <div className="tw-relative tw-z-10 animate-float">
                <img
                  src={BannerImage2}
                  className="tw-max-w-full tw-h-auto tw-object-contain img-shadow-indigo"
                  alt="About BeyondLeadz"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── Go Beyond Section ── */}
      <section className="tw-relative tw-bg-slate-50/40 tw-py-16 sm:tw-py-20 tw-border-b tw-border-solid tw-border-slate-100">
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-text-center">
          
          <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 sm:tw-p-12 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300">
            <p className="tw-text-base tw-font-bold tw-text-[#5D44FF] tw-italic tw-mb-4 tw-text-left">
              Go Beyond
            </p>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-text-left">
              <strong> BeyondLeadz goes far beyond traditional lead generation—it's a complete growth and engagement engine for the hospitality sector.</strong> Developed by <strong>hospitality industry experts with deep experience in sales and marketing,</strong> BeyondLeadz is built to solve real-world challenges faced by hotels, resorts, and travel businesses. From managing guest reviews and automating personalized messages to organizing your sales calendar with AI and tracking guest interactions in real-time, the platform combines smart automation with actionable insights to help you elevate every stage of the guest journey. With BeyondLeadz, your team stays connected, responsive, and always one step ahead.
            </p>
          </div>

        </div>

        {/* Bottom wave divider */}
        <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-overflow-hidden tw-leading-none">
          <svg className="tw-relative tw-block tw-w-full tw-h-8" viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,32L120,53.3C240,75,480,117,720,117C960,117,1200,75,1320,53.3L1440,32L1440,120L1320,120C1200,120,960,120,720,120C480,120,240,120,120,120L0,120Z" fill="#ffffff" fillOpacity="1"></path>
          </svg>
        </div>
      </section>
    </>
  );
};

export default BannerSection;
